import React from "react";
import { Routes, Route, NavLink } from "react-router-dom";

// Import stránek a komponent
import HomePage from "./pages/HomePage/HomePage";
import DiceRoller from "./components/DiceRoller/DiceRoller";
import NumberGenerator from "./components/NumberGenerator/NumberGenerator";
import RandomListGenerator from "./components/RandomListGenerator/RandomListGenerator";
import WheelOfFortune from "./components/WheelOfFortune/WheelOfFortune";
import Teams from "./components/Teams/Teams";

import styles from "./styles/App.module.scss";

function App() {
  return (
    <div className={styles.app}>
      {/* Horní globální menu */}
      <header className={styles.header}>
      <NavLink to="/" className={styles.noUnderline}>
  <div className={styles.logo}>RandGen</div>
</NavLink>

        <nav className={styles.nav}>
          <NavLink to="/" end>
            Domů
          </NavLink>
          <NavLink to="/dice">Kostka</NavLink>
          <NavLink to="/number">Čísla</NavLink>
          <NavLink to="/random">Výběr</NavLink>
          <NavLink to="/wheel">Kolo</NavLink>
          <NavLink to="/teams">Týmy</NavLink>
        </nav>
      </header>

      <main className={styles.main}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dice" element={<DiceRoller />} />
          <Route path="/number" element={<NumberGenerator />} />
          <Route path="/random" element={<RandomListGenerator />} />
          <Route path="/wheel" element={<WheelOfFortune />} />
          <Route path="/teams" element={<Teams />} />
        </Routes>
      </main>

      <footer className={styles.footer}>
        &copy; {new Date().getFullYear()} RandGen. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
